import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useLanguage } from "../i18n/LanguageContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { t } = useLanguage();

  if (loading) return <div>{t("Loading...")}</div>;

  if (!user) {
    return <Navigate to="/auth" />;
  }

  return children;
};

export default ProtectedRoute;
